import Images from "../Assets";

export const productData = {
  title1: "Featured Products",
  title2: "Top Rate Products",
  title3: "Recently Viewed Products",
  featured: [
    {
      id: 1,
      describtion: "Apple iPhone 11 Pro 256GB Memory",
      rate: "4.5",
      price: "$499.99",
      image: Images.Img20,
    },
    {
      id: 2,
      describtion: "Apple Airpods Wireless Bluetooth Headset",
      rate: "4",
      price: "$99.99",
      image: Images.Img7,
    },
    {
      id: 3,
      describtion: "Sony Playstation 4 Pro White Version",
      rate: "1",
      price: "$399.99",
      image: Images.Img6,
    },
  ],

  topRated: [
    {
      id: 1,
      describtion: "Canon Eos 80D DSLR Camera",
      rate: "4.5",
      price: "$799.99",
      image: Images.Img11,
    },
    {
      id: 2,
      describtion: "Logitech G-Series Gaming Mouse",
      rate: "5",
      price: "$49.99",
      image: Images.Img10,
    },
    {
      id: 3,
      describtion: "Amazon Echo Dot 3rd Generation",
      rate: "5",
      price: "$29.99",
      image: Images.Img9,
    },
  ],
  recentlyViewed: [
    {
      id: 1,
      title: "Featured Products",
      describtion: "Apple iPhone 11 Pro 256GB Memory",
      rate: 4.5,
      price: "$499.99",
      image: Images.Img20,
    },
  ],
};
